"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reopenLead = exports.rejectQuote = exports.rejectOptions = exports.rejectClientQuote = exports.rejectClientOptions = exports.quoteDelivered = exports.productSourced = exports.previewPresentationPdfUrl = exports.previewPdfUrl = exports.leadStatusCount = exports.getLeadsCount = exports.getLeadsBySourceCount = exports.getLeadsBarGraphData = exports.getLeads = exports.getLeadById = exports.getInquiryValue = exports.getEmployeePerformance = exports.deleteLead = exports.defaultLeadData = exports.createLead = exports.checkDuplicate = exports.approveQuote = exports.approveOptions = exports.approveClientQuote = exports.approveClientOptions = exports.addPODetails = exports.addMaskingRequest = void 0;
exports.resolveFromEmail = resolveFromEmail;
exports.updateLead = exports.sendForAdminApproval = exports.sendDirectToClient = exports.sendDirectOptionsToClient = exports.reviseClientQuote = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultLeadDataRaw = {
  id: 0,
  enabled: true,
  prNumber: undefined,
  status: null,
  expectedClosureDate: null,
  enquiryValue: undefined,
  closureProbability: null,
  levelType: null,
  companyId: null,
  productAction: 'Send Options',
  isSampleRequired: false,
  isSampleSent: false,
  sampleReturnDate: null,
  isQuotationRequired: false,
  needToOutsource: false,
  nextFollowupDuration: '01:00',
  attachment1: null,
  attachment2: null,
  attachment3: null,
  selectedProduct: [],
  quantity: 10,
  budgetPerPiece: 0,
  budget: 0,
  tentativeDeliveryDuration: 1,
  comments: null,
  quoteExtraNote: null,
  quotationStatus: null,
  clientId: null,
  client: {
    id: null
  },
  clientsContactId: null,
  clientsContact: {
    id: null
  },
  salesCoordinatorId: null,
  salesCoordinator: {
    id: null
  },
  salesManagerId: null,
  salesManager: {
    id: null
  },
  sourceId: null,
  source: {
    id: null
  },
  conceptId: null,
  concept: {
    id: null
  },
  reasonId: null,
  reason: {
    id: null
  },
  category: [],
  categorization: '',
  sourcingProductName: '',
  sourcingProductImage: []
};
const defaultLeadData = exports.defaultLeadData = defaultLeadDataRaw;
const getLeads = params => (0, _request.default)({
  url: '/leads',
  method: 'get',
  params
});
exports.getLeads = getLeads;
const getLeadById = id => (0, _request.default)({
  url: `/leads/${id}`,
  method: 'get'
});
exports.getLeadById = getLeadById;
const updateLead = (id, data) => (0, _request.default)({
  url: `/leads/${id}`,
  method: 'patch',
  data
});
exports.updateLead = updateLead;
const deleteLead = id => (0, _request.default)({
  url: `/leads/${id}`,
  method: 'delete'
});
exports.deleteLead = deleteLead;
const createLead = data => (0, _request.default)({
  url: '/leads/',
  method: 'post',
  data
});
exports.createLead = createLead;
const sendForAdminApproval = data => (0, _request.default)({
  url: '/leads/request-quote-approval',
  method: 'post',
  data
});
exports.sendForAdminApproval = sendForAdminApproval;
const sendDirectToClient = data => (0, _request.default)({
  url: '/leads/send-direct-to-client',
  method: 'post',
  data
});
exports.sendDirectToClient = sendDirectToClient;
const sendDirectOptionsToClient = data => (0, _request.default)({
  url: '/leads/send-direct-options-to-client',
  method: 'post',
  data
});
exports.sendDirectOptionsToClient = sendDirectOptionsToClient;
const approveOptions = data => (0, _request.default)({
  url: '/leads/approve-options',
  method: 'post',
  data
});
exports.approveOptions = approveOptions;
const approveQuote = data => (0, _request.default)({
  url: '/leads/approve-quote',
  method: 'post',
  data
});
exports.approveQuote = approveQuote;
const rejectOptions = data => (0, _request.default)({
  url: '/leads/reject-options',
  method: 'post',
  data
});
exports.rejectOptions = rejectOptions;
const rejectQuote = data => (0, _request.default)({
  url: '/leads/reject-quote',
  method: 'post',
  data
});
exports.rejectQuote = rejectQuote;
const approveClientOptions = data => (0, _request.default)({
  url: '/leads/approve-client-options',
  method: 'post',
  data
});
exports.approveClientOptions = approveClientOptions;
const approveClientQuote = data => (0, _request.default)({
  url: '/leads/approve-client-quote',
  method: 'post',
  data
});
exports.approveClientQuote = approveClientQuote;
const rejectClientOptions = data => (0, _request.default)({
  url: '/leads/reject-client-options',
  method: 'post',
  data
});
exports.rejectClientOptions = rejectClientOptions;
const rejectClientQuote = data => (0, _request.default)({
  url: '/leads/reject-client-quote',
  method: 'post',
  data
});
exports.rejectClientQuote = rejectClientQuote;
const reviseClientQuote = data => (0, _request.default)({
  url: '/leads/revise-client-quote',
  method: 'post',
  data
});
exports.reviseClientQuote = reviseClientQuote;
const checkDuplicate = data => (0, _request.default)({
  url: '/leads/check-duplicate',
  method: 'post',
  data
});
exports.checkDuplicate = checkDuplicate;
const leadStatusCount = data => (0, _request.default)({
  url: '/leads/status-count',
  method: 'post',
  data
});
exports.leadStatusCount = leadStatusCount;
const previewPdfUrl = id => (0, _request.default)({
  url: `/leads/quote-preview/${id}`,
  method: 'get'
});
exports.previewPdfUrl = previewPdfUrl;
const previewPresentationPdfUrl = id => (0, _request.default)({
  url: `/leads/option-preview/${id}`,
  method: 'get'
});
exports.previewPresentationPdfUrl = previewPresentationPdfUrl;
const addPODetails = data => (0, _request.default)({
  url: '/leads/po-details',
  method: 'post',
  data
});
exports.addPODetails = addPODetails;
const addMaskingRequest = data => (0, _request.default)({
  url: '/masking-requests',
  method: 'post',
  data
});
exports.addMaskingRequest = addMaskingRequest;
const getInquiryValue = params => (0, _request.default)({
  url: 'leads/inquiry-value',
  method: 'get',
  params
});
exports.getInquiryValue = getInquiryValue;
const getEmployeePerformance = params => (0, _request.default)({
  url: 'leads/employee-performance',
  method: 'get',
  params
});
exports.getEmployeePerformance = getEmployeePerformance;
const getLeadsCount = params => (0, _request.default)({
  url: 'leads/count',
  method: 'get',
  params
});
exports.getLeadsCount = getLeadsCount;
const getLeadsBySourceCount = params => (0, _request.default)({
  url: 'leads/count-by-source',
  method: 'get',
  params
});
exports.getLeadsBySourceCount = getLeadsBySourceCount;
const getLeadsBarGraphData = params => (0, _request.default)({
  url: 'leads/bar-chart-data',
  method: 'get',
  params
});
exports.getLeadsBarGraphData = getLeadsBarGraphData;
const productSourced = data => (0, _request.default)({
  url: '/leads/products-sourced',
  method: 'post',
  data
});
exports.productSourced = productSourced;
const quoteDelivered = data => (0, _request.default)({
  url: '/leads/quote-delivered',
  method: 'post',
  data
});
exports.quoteDelivered = quoteDelivered;
const reopenLead = leadId => (0, _request.default)({
  url: '/leads/reopen',
  method: 'post',
  data: {
    leadId
  }
});
exports.reopenLead = reopenLead;
function resolveFromEmail(email) {
  return (0, _request.default)({
    url: '/leads/resolve-from-email',
    method: 'get',
    params: {
      email
    }
  });
}